import { annotate } from '../annotate.mjs'
import { define } from '../Decoder.mjs'

export var poja = define(function (blob, ok, err) {
  if (!Array.isArray(blob)) {
    return err('Must be an array')
  }
  return ok(blob.slice())
})

function all(items, blobs, ok, err) {
  var results = []
  for (var index = 0; index < items.length; ++index) {
    var result = items[index]
    if (result.ok) {
      results.push(result.value)
    } else {
      var ann = result.error
      var clone = [].concat(blobs)
      clone.splice(index, 1, annotate(ann, ann.text ? ann.text + ' (at index ' + index + ')' : 'index ' + index))
      return err(annotate(clone))
    }
  }
  return ok(results)
}

export function array(decoder) {
  return poja.then(function (blobs, ok, err) {
    var results = blobs.map(decoder.decode)
    return all(results, blobs, ok, err)
  })
}

export function nonEmptyArray(decoder) {
  return array(decoder).refine(function (arr) {
    return arr.length > 0
  }, 'Must be non-empty array')
}

export function set(decoder) {
  return array(decoder).transform(function (items) {
    return new Set(items)
  })
}
var ntuple = function ntuple(n) {
  return poja.refine(function (arr) {
    return arr.length === n
  }, 'Must be a ' + n + '-tuple')
}

function _tuple() {
  for (var _len = arguments.length, decoders = new Array(_len), _key = 0; _key < _len; _key++) {
    decoders[_key] = arguments[_key]
  }
  return ntuple(decoders.length).then(function (blobs, ok, err) {
    var allOk = true
    var rvs = decoders.map(function (decoder, i) {
      var blob = blobs[i]
      var result = decoder.decode(blob)
      if (result.ok) {
        return result.value
      } else {
        allOk = false
        return result.error
      }
    })
    if (allOk) {
      return ok(rvs)
    } else {
      return err(annotate(rvs))
    }
  })
}

export var tuple = _tuple
